// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span[data-v-559d4666] {\n  font-size: 14px;\n}\n.el-image[data-v-559d4666] {\n  width: 200px;\n  height: 150px;\n  vertical-align: top;\n}\n.twomargin[data-v-559d4666] {\n  margin: 20px 0;\n}\n.el-select[data-v-559d4666] {\n  display: inline-block;\n}\n[data-v-559d4666] .el-textarea__inner {\n  width: 650px;\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
